
/*
 * Stoke Equipment Co — Cart Upsells
 * Handles one-click accessory additions.
 * Uses delegated click handling so it survives Shopify cart refreshes.
 */

if (!window.__stokeCartUpsellsLoaded) {
  window.__stokeCartUpsellsLoaded = true;

  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-stoke-upsell-variant]');

    if (!button || button.disabled) return;

    event.preventDefault();

    const variantId = Number(button.dataset.stokeUpsellVariant);

    if (!Number.isSafeInteger(variantId) || variantId <= 0) return;

    const upsell = button.closest('.stoke-upsell');
    const error = upsell?.querySelector('.stoke-upsell__error');
    const originalText = button.textContent;
    const isDrawer = Boolean(button.closest('cart-drawer'));

    const root = window.Shopify?.routes?.root || '/';

    if (error) {
      error.hidden = true;
      error.textContent = '';
    }

    button.disabled = true;
    button.textContent = 'Adding…';

    let itemAdded = false;

    try {
      // Add accessory to Shopify cart.
      const response = await fetch(`${root}cart/add.js`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: variantId,
          quantity: 1
        })
      });

      if (!response.ok) {
        const data = await response.json().catch(() => ({}));

        throw new Error(
          data.description ||
          data.message ||
          'Unable to add this item.'
        );
      }

      itemAdded = true;
      button.textContent = 'Added ✓';

      // Full cart: reload to update totals, recommendations
      // and any existing freight acknowledgement logic.
      if (!isDrawer) {
        window.location.reload();
        return;
      }

      // Drawer: fetch refreshed Shopify sections.
      const sectionsResponse = await fetch(
        `${root}cart?sections=cart-drawer,cart-icon-bubble`
      );

      if (!sectionsResponse.ok) {
        throw new Error('Cart updated. Please refresh to see it.');
      }

      const sections = await sectionsResponse.json();

      if (!sections['cart-drawer']) {
        throw new Error('Cart updated. Please refresh to see it.');
      }

      const drawer = document.querySelector('cart-drawer');
      if (!drawer || typeof drawer.renderContents !== 'function' || !sections['cart-icon-bubble']) {
        window.location.reload();
        return;
      }

      // Use Ride's own full drawer renderer, including the cart icon.
      // Never replace only individual cart items; that risks stale line indices.
      drawer.renderContents({ id: variantId, sections });

    } catch (e) {
      console.error('Stoke cart upsell:', e);

      if (itemAdded) {
        // Addition succeeded, but refreshing the drawer failed.
        // Reload instead of encouraging a duplicate addition.
        window.location.reload();
        return;
      }

      if (error) {
        error.textContent =
          e.message || 'Could not add this item.';
        error.hidden = false;
      }

      button.textContent = originalText;

    } finally {
      button.disabled = false;
    }
  });
}

// Stoke upsell carousel arrows.
// Delegated so buttons survive Shopify drawer refreshes.
if (!window.__stokeUpsellCarouselLoaded) {
  window.__stokeUpsellCarouselLoaded = true;

  document.addEventListener('click', (event) => {
    const arrow = event.target.closest('[data-stoke-slide]');
    if (!arrow) return;

    event.preventDefault();

    const upsell = arrow.closest('.stoke-upsell');
    const track = upsell?.querySelector('.stoke-upsell__cards');
    const card = track?.querySelector('.stoke-upsell__item');

    if (!track || !card) return;

    const gap = parseFloat(getComputedStyle(track).columnGap) || 0;
    const distance = card.getBoundingClientRect().width + gap;
    const direction = arrow.dataset.stokeSlide === 'next' ? 1 : -1;

    track.scrollBy({
      left: distance * direction,
      behavior: 'smooth'
    });
  });
}
